import { DIALOG, type PaymentItemProps } from '@/types';
import { ActionIcon, Card, Group, Image, Radio, Stack, Text } from '@mantine/core';
import { IconPencil, IconTrash } from '@tabler/icons-react';
export type InfoPaymentMethodItemProps = PaymentItemProps & {
  setOpenDialog: (modal: DIALOG | null) => void;
};
export const InfoPaymentMethodItem: React.FC<InfoPaymentMethodItemProps> = ({
  paymentName,
  endCode,
  checked,
  value,
  handleClick,
  setOpenDialog
}) => {
  return <Group gap={12}>
      <Card flex={1} radius={5} bg="linear-gradient(103.61deg, #363D43 1.86%, #282D32 100%)" p={12}>
        <Group justify="space-between">
          <Group>
            <Radio color="var(--text-prime)" variant="outline" value={value} checked={checked} onChange={handleClick} />
            <Stack gap={0}>
              <Text fz="xs" tt="uppercase" c="var(--text-dark)">
                {`${paymentName} ending in ${endCode}`}
              </Text>
              <Text fz="xs" c="var(--text-grey-2)">
                {'Expires 07/28'}
              </Text>
            </Stack>
          </Group>
          <Image src="/assets/wallet/visa.png" alt="visa" w={54} h={18} />
        </Group>
      </Card>

      <Group gap={12}>
        <ActionIcon variant="transparent" onClick={() => setOpenDialog(DIALOG.EDIT_PAYMENT)}>
          <IconPencil size={20} color="var(--text-dark)" />
        </ActionIcon>

        <ActionIcon variant="transparent" onClick={() => setOpenDialog(DIALOG.DEL_PAYMENT)}>
          <IconTrash size={20} color="var(--text-dark)" />
        </ActionIcon>
      </Group>
    </Group>;
};